import React, { PropTypes } from 'react';
import { equals, call, ifElse, and, isEmpty, or, always } from 'ramda';
import GenericPageLayout from '../generic-page-layout';
import AccomTable from './accom-table';
import NonAccomTable from './nonaccom-table';

const CompanyOperation = props => {
  const {
    dispatchedUpdateProps,
    step,
    oneOrMultiProperties,
    numOfProperties,
    numOfIndicatorDots,
    goToSignUpForm,
    oneOrMultiCities,
    selectedCompanyType,
    backButtonFunc,
  } = props;

  const checkIfNumOfPropertiesIsEmpty = and(equals(oneOrMultiProperties, 'multi-prop'), isEmpty(numOfProperties));
  const checkIfAccomButtonIsDisabled = () => or(isEmpty(oneOrMultiProperties), checkIfNumOfPropertiesIsEmpty);

  return (
    <GenericPageLayout
      pageDesc={'To make setting up your profile easier, please let us know how your company operates.'}
      boldedTableDesc={call(ifElse(
        equals('Accommodation'),
          always('How many properties do you own/manage?'),
        always('How many cities do you operate in?')
      ), selectedCompanyType)}
      dispatchedUpdateProps={dispatchedUpdateProps}
      numOfIndicatorDots={numOfIndicatorDots}
      step={step}
      nextButtonDisabled={call(ifElse(
        equals('Accommodation'),
          checkIfAccomButtonIsDisabled,
        () => isEmpty(oneOrMultiCities)
      ), selectedCompanyType)}
      tableInfo={call(ifElse(
        equals('Accommodation'),
          () => <AccomTable dispatchedUpdateProps={dispatchedUpdateProps} oneOrMultiProperties={oneOrMultiProperties}/>,
        () => <NonAccomTable dispatchedUpdateProps={dispatchedUpdateProps} />
      ), selectedCompanyType)}
      outsideTable
      onNextClick={goToSignUpForm}
      minHeight={"410px"}
      backButtonFunc={backButtonFunc}
    />
  );
};

CompanyOperation.propTypes = {
  numOfIndicatorDots: PropTypes.number,
  dispatchedUpdateProps: PropTypes.func,
  step: PropTypes.number,
  oneOrMultiProperties: PropTypes.string,
  numOfProperties: PropTypes.string,
  goToSignUpForm: PropTypes.func,
  oneOrMultiCities: PropTypes.string,
  selectedCompanyType: PropTypes.string,
  backButtonFunc: PropTypes.func,
};

export default CompanyOperation;



// WEBPACK FOOTER //
// ./src/app/components/signup/supplier/company-operations.jsx